const cornflowerBlue = {
  300: "#9EBEF8",
  500: "#6899F4",
  700: "#43629C",
};

export default cornflowerBlue;
